var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Wrapper',{attrs:{"visible":_vm.visible}},_vm._l((_vm.menuList),function(item){return _c('Item',{key:item.title},[_c('Link',{on:{"click":function($event){return _vm.$emit(item.click)}}},[_c(item.component,{tag:"component"}),_vm._v(" "+_vm._s(item.title)+" ")],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }